import { render, staticRenderFns } from "./ChipButtons.vue?vue&type=template&id=17d4e354"
import script from "./ChipButtons.vue?vue&type=script&lang=ts"
export * from "./ChipButtons.vue?vue&type=script&lang=ts"
import style0 from "./ChipButtons.vue?vue&type=style&index=0&id=17d4e354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports